import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_EDITED_TOTAL_BILL } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const editedTotalBill = {
  namespaced: true,
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus
  },
  actions: {
    getEditedTotalBill ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting total bill, please wait...' })
      return api.doGet({ path: PATH_EDITED_TOTAL_BILL, parameters: filters })
        .then(json => json.data)
        .then(editedTotalBill => {
          commit('updateStatus', { status: COMPLETE })
          return editedTotalBill[0]
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get total bill')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveEditedTotalBill ({ commit, dispatch }, editedTotalBill) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving total bill, please wait...' })

      return api.doPost({ path: PATH_EDITED_TOTAL_BILL, data: editedTotalBill })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save total bill.')
          }

          notifySuccess(dispatch, 'Total bill saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save total bill')

          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    updateEditedTotalBill ({ commit, dispatch }, editedTotalBill) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving total bill, please wait...' })

      return api.doPut({ path: PATH_EDITED_TOTAL_BILL, data: editedTotalBill })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save total bill.')
          }

          notifySuccess(dispatch, 'Total bill saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save total bill')

          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default editedTotalBill
